import { SVGProps } from 'react';

const SvgChevronRightSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M6.646 11.354a.5.5 0 0 1 0-.708L9.293 8 6.646 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgChevronRightSmall;
